import {makeAutoObservable} from 'mobx';

class Login {
    username = '';
    password = '';
    show = false;

    constructor() {
        makeAutoObservable(this)
    }

    openLoginPanel(){
        this.show = true;
    }

    closeLoginPanel(){
        this.show = false;
    }
}

const login = new Login();

export default login;
